type OnImageChangeOptions = {
  set: (key: string, value: string | number) => void;
  get: (key: string) => string | number | undefined;
};

export const onImageChange = (options: OnImageChangeOptions) => {
  function loadImage(url: string, timeout = 60000): Promise<HTMLImageElement> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const cleanup = () => {
        clearTimeout(timer);
        img.onload = null;
        img.onerror = null;
      };
      const timer = setTimeout(() => {
        cleanup();
        reject(new Error(`Image load timed out: ${url}`));
      }, timeout);

      img.onload = () => {
        cleanup();
        resolve(img);
      };

      img.onerror = (err) => {
        cleanup();
        // eslint-disable-next-line no-console
        console.warn(`Image load failed: ${url}`, err);
        reject(err instanceof Error ? err : new Error(`Image load failed: ${url}`));
      };

      img.src = url;
    });
  }

  function round(num: number) {
    return Math.round(num * 1000) / 1000;
  }

  const value = options.get("image");

  if (value && typeof value === "string") {
    return loadImage(value).then((img) => {
      if (img.width && img.height) {
        options.set("aspectRatio", round(img.width / img.height));
        options.set("height", img.height);
        options.set("width", img.width);
      }
    });
  }
};
